import { createSelector } from 'reselect'

import { ToasterState } from './reducers'

export const selectToasterState = (state: { toaster: ToasterState }) =>
  state && state.toaster

const toasts = createSelector([selectToasterState], state => state?.toasts)

export const ToasterSelector = {
  toasts,
}
